import Vue from 'vue'

export async function getUser ({ commit }, userID) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setUser', null)
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/v1/users/${userID}`
    })
    commit('setUser', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function updateUser ({ commit }, user) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    const { data } = await Vue.axios({
      method: 'PUT',
      url: `/v1/users/${user.user_id}`,
      data: user
    })
    commit('setUser', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}
